export const sortCards = (cards) => {
    return [...cards].sort((a, b) => {
        var _a, _b, _c, _d;
        const initiativeDiff = Number((_a = b.initiative) !== null && _a !== void 0 ? _a : 0) - Number((_b = a.initiative) !== null && _b !== void 0 ? _b : 0);
        if (initiativeDiff !== 0)
            return initiativeDiff;
        const aId = (_c = a.id) !== null && _c !== void 0 ? _c : 0;
        const bId = (_d = b.id) !== null && _d !== void 0 ? _d : 1;
        return aId - bId;
    });
};
export const isEqualArrays = (a, b) => a.length === b.length && a.every((v, i) => v === b[i]);
export const sortSpells = (arr) => arr.sort((a, b) => {
    var _a, _b;
    const aLevel = (_a = a.level) !== null && _a !== void 0 ? _a : 0;
    const bLevel = (_b = b.level) !== null && _b !== void 0 ? _b : 0;
    if (aLevel !== bLevel)
        return aLevel - bLevel;
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
});
